import React, { ReactNode } from 'react'
import TooltipLabel from './TooltipLabel'

const FormSection = ({
  title,
  hint,
  tooltip,
  children
}: {
  title: string
  hint?: string
  tooltip?: string
  children: ReactNode
}) => (
  <div className="dosing-mode-form__section">
    <h6 className="dosing-mode-form__section-title">
      <TooltipLabel text={title} tooltip={tooltip} />
    </h6>
    {hint && (
      <div className="dosing-mode-form__hint dosing-mode-form__hint--section">
        {hint}
      </div>
    )}
    {children}
  </div>
)

export default FormSection
